import { createSlice } from '@reduxjs/toolkit'

const contractComparison = createSlice({
  name: 'contractComparison',
  initialState: {
    contractComparisonWACData: [],
    isContractComparisonRefresh: false,
    isCopyContractComparison: false,
    selectedContractStructureTemplatesIds: [],
    updatedDefaultAlignment: '',
    selectedWacId: null,
    isPolling: false,
    columns: [],
    dataSource: [],
    tableParamsContractComparisonWac: {
      pagination: {
        current: 1,
        pageSize: 10
        // total: 50,
      }
    }
  },

  reducers: {
    updateContractComparisonWACData: (state, action) => {
      state.contractComparisonWACData = action.payload
    },
    updatedDefaultAlignment: (state, action) => {
      state.updatedDefaultAlignment = action.payload
    },
    updateTableParamsContractComparisonWac: (state, action) => {
      state.tableParamsContractComparisonWac = action.payload
    },
    updateIsCopyContractComparison: (state, action) => {
      state.isCopyContractComparison = action.payload
    },
    updateisContractComparisonRefresh: (state, action) => {
      state.isContractComparisonRefresh = action.payload
    },
    updateSelectedContractStructureTemplatesIds: (state, action) => {
      state.selectedContractStructureTemplatesIds = action.payload
    },
    updateSelectedWACId: (state, action) => {
      state.selectedWacId = action.payload
    },
    setColumns: (state, action) => {
      state.columns = action.payload
    },
    setDataSource: (state, action) => {
      state.dataSource = action.payload
    },
    setIsPolling: (state, action) => {
      state.isPolling = action.payload
    }
  }
})

export const {
  updateContractComparisonWACData,
  updatedDefaultAlignment,
  updateTableParamsContractComparisonWac,
  updateSelectedContractStructureTemplatesIds,
  updateSelectedWACId,
  setColumns,
  setDataSource,
  setIsPolling,
  updateisContractComparisonRefresh,
  updateIsCopyContractComparison
} = contractComparison.actions
export default contractComparison.reducer
